import { Asterisk } from "lucide-react";

const BRANDS = ["NIKE", "JORDAN", "ADIDAS", "NEW BALANCE", "ON", "MIZUNO"];

export function Marquee() {
  const row = [...BRANDS, ...BRANDS];
  return (
    <section id="marcas" className="overflow-hidden border-y-2 border-slate-900 bg-white py-5">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((b, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-4xl font-black uppercase italic tracking-tight sm:text-5xl ${i % 2 === 0 ? "text-slate-900" : "text-stroke-ink"}`}>
              {b}
            </span>
            <Asterisk size={28} className="shrink-0 text-vult-red" />
          </span>
        ))}
      </div>
    </section>
  );
}
